
import { getMaterialInfo } from '@/api/res_store/info';
import { fmtSize } from '@/filters/index';
import * as api from '@/config/api';
export default {
  data: function data() {
    return {
      bLoading: true,
      sId: '',
      oInfo: {},
      sPreviewUrl: ''
    };
  },

  computed: {
    downloadUrl: {
      get: function get() {
        return api.resStoreDownloadUrl;
      }
    },
    fileFormat: {
      get: function get() {
        if (this.oInfo.file_list && this.oInfo.file_list.length) {
          var aFileTemp = [];
          this.oInfo.file_list.forEach(function (e) {
            var aTemp = e.name.split('.');
            var sFile = String(aTemp[aTemp.length - 1]).toLowerCase();
            if (['fbx', '3ds', 'obj', 'max', 'mb'].indexOf(sFile) !== -1) {
              aFileTemp.push(sFile + '（' + fmtSize(e.size) + '）');
            }
          });
          return aFileTemp.join();
        }
        return '';
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.sId = this.$route.params.id;
    if (this.$route.params.id) {
      this.bLoading = true;
      getMaterialInfo({
        id: this.$route.params.id
      }).then(function (res) {
        _this.oInfo = res.data.data.info;
        _this.bLoading = false;
        var sName = _this.oInfo.name.length > 20 ? _this.oInfo.name.substr(0, 10) + '...' : _this.oInfo.name;
        document.querySelector('.app-breadcrumb .u-breadcrumb-cur').innerHTML = '详情: ' + sName;
        var fbxUrl = '';
        _this.oInfo.preview_urls.forEach(function (e) {
          var aTemp = e.split('.');
          if (String(aTemp[aTemp.length - 1]).toLowerCase() === 'fbx') {
            fbxUrl = decodeURIComponent(e);
          }
        });
        if (_this.oInfo.tag1_list && _this.oInfo.tag1_list.length && _this.oInfo.tag1_list.findIndex(function (e) {
          return e.name === '蒙皮';
        }) !== -1) {
          _this.sPreviewUrl = '/common-viewer/?url=' + fbxUrl + '&type=model';
        } else {
          _this.sPreviewUrl = '/common-viewer/?url=' + fbxUrl + '&type=animation';
        }
      }).catch(function () {
        _this.bLoading = false;
      });
    }
  }
};